import React, {useEffect, useState} from "react";
import "../styles/DownloadCenter.css";

const forms = [
{
title:"Saving Account Opening Form",
desc:"Open a savings account by filling this application form.",
file:"/forms/savings-form.pdf",
size:"11.2 MB",
icon:"🏦"
},

{
title:"Current Account Opening Form",
desc:"Application form to open a current account for businesses.",
file:"/forms/current-form.pdf",
size:"515 KB",
icon:"🏢"
},

{
title:"KYC Form",
desc:"Know Your Customer form required for identity verification.",
file:"/forms/kyc.pdf",
size:"3.25 MB",
icon:"🪪"
},

{
title:"CKYC Form",
desc:"Central KYC registration form for banking services.",
file:"/forms/ckyc-form.pdf",
size:"422 KB",
icon:"📑"
},

{
title:"Term Deposit Opening Form",
desc:"Apply for fixed / term deposit using this form.",
file:"/forms/term-deposit-form.pdf",
size:"455 KB",
icon:"💰"
}
];

function DownloadCenter(){

const [downloads,setDownloads]=useState(0);

useEffect(()=>{

let count=0;
let target=10245;

let interval=setInterval(()=>{

count+=120;

if(count>=target){
count=target;
clearInterval(interval);
}

setDownloads(count);

},20);

return ()=>clearInterval(interval);

},[]);

return(

<div className="download-wrapper">

{/* HERO */}

<section className="download-hero">

<h1>Download Center</h1>

<p>Access important banking forms quickly and download instantly</p>

</section>


{/* COUNTER */}

<section className="forms-counter">

<div className="counter-box">

Forms Available : <strong>5</strong>

</div>

</section>


{/* FORMS */}

<section className="forms-section">

<div className="forms-grid">

{forms.map((form,index)=>(
<div className="form-card" key={index}>

<div className="form-icon">{form.icon}</div>

<h3>{form.title}</h3>

<p>{form.desc}</p>

<div className="file-info">Format: PDF | Size: {form.size}</div>

<a href={form.file} className="download-btn" download>

Download PDF

</a>

</div>
))}

</div>

</section>


{/* HOW TO APPLY */}

<section className="how-section">

<h2>How to Apply</h2>

<ul className="steps">

<p>Step 1: Download the required form</p>

<p>Step 2: Fill all necessary details</p>

<p>Step 3: Attach KYC documents</p>

<p>Step 4: Submit the form at your nearest branch</p>

</ul>

</section>


{/* HELP */}

<section className="help-section">

<div className="help-box">

<h2>Need Help Filling Forms?</h2>

<p>Visit your nearest branch or contact customer support.</p>

<p>📞 Customer Care : 022 22033557</p>

<p>✉ Email : support@thesahyadribank.com</p>

</div>

</section>

</div>

);

}

export default DownloadCenter;